import { memo } from "react";
import { motion, useReducedMotion } from "framer-motion";

const PILL_SPRING = { type: "spring", stiffness: 520, damping: 42, mass: 0.9 };
const REDUCED_MOTION_TRANSITION = { duration: 0 };

const SidebarActivePill = ({ pill }) => {
  const prefersReducedMotion = useReducedMotion();
  const { x = 0, y = 0, width = 0, height = 0, opacity = 0 } = pill || {};

  return (
    <motion.div
      className="sidebar-active-pill"
      aria-hidden="true"
      initial={false}
      animate={{ x, y, width, height, opacity }}
      transition={prefersReducedMotion ? REDUCED_MOTION_TRANSITION : PILL_SPRING}
    />
  );
};

export default memo(SidebarActivePill);
